import React from 'react'

import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './report_link.less'
import { getI18n } from 'client/i18n'
import { trackClick } from 'lib/fpti_analytics'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const i18n = getI18n('components/report_link')
const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

class ReportLink extends React.Component {
  static propTypes = {
    currentUserCountryCode: PropTypes.string,
    campaignId: PropTypes.string,
    campaignType: PropTypes.string,
    paypalDomain: PropTypes.string,
    charity: PropTypes.object,
  }

  static defaultProps = {
    currentUserCountryCode: 'US',
  }

  getReportPoolLink = (country = 'US') => {
    return `https://${
      this.props.paypalDomain
    }/${country}/smarthelp/contact-us?email=paypalme`
  }

  handleReportPoolClick = () => {
    trackClick({
      clickName: 'report_pool_pressed',
      data: {
        event_name: 'dw_giving_view_fundraiser_report_pressed',
        flow: this.props.charity
          ? 'GENEROSITY_NETWORK_CHARITIES'
          : 'GENEROSITY_NETWORK',
      },
    })
  }

  render() {
    const { currentUserCountryCode } = this.props

    return (
      <div styleName="report-link-container">
        <a
          href={this.getReportPoolLink(currentUserCountryCode)}
          target="_blank"
          onClick={this.handleReportPoolClick}
        >
          {this.props.campaignType === CROWD_FUNDING
            ? i18n('report_this_campaign')
            : i18n('report_this_pool')}
        </a>
      </div>
    )
  }
}

export default cssModules(ReportLink, styles)
